/* istanbul ignore file */
import { Box } from '@cambridgeassessment/cambridge-ui';
import React from 'react';
import useWindowDimensions from 'src/hooks/useWindowDimensions';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import GlobalHeader, { screenSize } from './GlobalHeader';
import { useStyles } from './styles';

interface PublicLayoutProps {
  authenticated?: boolean;
  children?: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({
  authenticated,
  children,
}) => {
  const classes = useStyles();
  const { width } = useWindowDimensions();

  return (
    <Box className={classes.app}>
      <Box className={classes.headerWrapper}>
        {width > 1024 && <GlobalHeader size={screenSize.Desktop} />}
        {authenticated ? <Header isAuthenticated /> : <Header />}
      </Box>

      <Box
        id="mainContainer"
        className={`${classes.mainContainer} ${classes.public}`}
      >
        <Box className={classes.publicContentContainer}>{children}</Box>
      </Box>
      <Box id="footer">
        <Footer />
        {width < 1025 && <GlobalHeader size={screenSize.Mobile} />}
      </Box>
    </Box>
  );
};

export default PublicLayout;
